import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { 
    IonModal, IonContent, IonSpinner, IonIcon
} from '@ionic/angular/standalone';

import { DemoozModalService } from '@demooz/services';
import { DataService, PwaAnalyticsService } from '@app/services';
import { OperationStory } from '@app/models';

@Component({
    selector: 'app-stories-player',
    templateUrl: './player.component.html',
    styleUrls: ['./player.component.scss'],
    imports: [
        IonModal, IonContent, IonSpinner, IonIcon
    ]
})
export class StoriesPlayerComponent  implements OnInit {
    
    @ViewChild('modalStory') modalStory: IonModal;
    @ViewChild('storyVideoPlayer') storyVideoPlayer: ElementRef;
    
    stories: Array<OperationStory> = [];
    isFetchingStory: boolean = false;
    indexVideo: number = 0;
    tabProgressValues: Array<number> = [];
    
    constructor(      
        private demoozModalService: DemoozModalService,
        public dataService: DataService,
        public pwaAnalyticsService: PwaAnalyticsService
    ) { }

    ngOnInit() {
        this.stories = this.dataService.operation.getStoriesSorted(this.dataService.ambassador);
    }
    
    async openStory(storyID: string){
        
        this.isFetchingStory = true;        
        this.indexVideo = this.stories.findIndex(s => s.ID === storyID) || 0;
        this.tabProgressValues = [];
                      
        for(let i=0;i<this.stories.length;i++){
            if(i<this.indexVideo){
                this.tabProgressValues[i] = 100;
            }
            else{
                this.tabProgressValues[i] = 0;
            }
        }               
            
        await this.demoozModalService.open(this.modalStory);        
        this.initEventVideo();     
        this.loadVideo();
    }
    
    async dismiss() {        
        await this.modalStory.dismiss();
    }
    
    async canDismissStoryModal(data?: any, role?: string) {
        return role !== 'gesture';
    }
    
    async onDidDismissStoryModal($event: any){  
        this.isFetchingStory = false;
        this.indexVideo = 0;
        this.tabProgressValues = [];
        this.demoozModalService.onDidDismiss($event);
    }    
    
    initEventVideo() {
    
        this.storyVideoPlayer.nativeElement.muted = false;  

        this.storyVideoPlayer.nativeElement.oncanplay = () => {
            this.isFetchingStory = false;
            this.storyVideoPlayer.nativeElement.play();
        };

        this.storyVideoPlayer.nativeElement.ontimeupdate = () => {
            if(this.storyVideoPlayer?.nativeElement){
                let duration = (this.storyVideoPlayer.nativeElement.currentTime ? this.storyVideoPlayer.nativeElement.currentTime : 0);
                let percent = (duration && this.storyVideoPlayer.nativeElement.duration ? Math.round((duration / this.storyVideoPlayer.nativeElement.duration)*100) : 0);
                this.tabProgressValues[this.indexVideo] = (percent > 100 ? 100 : percent);
            }
        };

        this.storyVideoPlayer.nativeElement.onended = () => {   
            this.nextStoryVideo(true);
        };

        this.storyVideoPlayer.nativeElement.oncontextmenu = (event: Event) => {
            event.preventDefault();
            return false;
        };

    }
    
    async loadVideo() {
        let story = this.stories[this.indexVideo];
        if(typeof story !== 'undefined'){ 
            if(!story.viewed){
                story.viewed = true;
                let tempStory = this.dataService.operation.value?._stories?.find((s: any) => s.ID === story.ID);
                let data = await this.pwaAnalyticsService.addStoryAnalytics(this.dataService.ambassador.value.ID, story.ID);
                if(data){
                    this.dataService.ambassador.value.pwaAnalytics = data;
                }
            }      
            this.storyVideoPlayer.nativeElement.querySelector('source').setAttribute('src', this.stories[this.indexVideo].url);        
            this.storyVideoPlayer.nativeElement.load(); 
        }
    }
    
    previousStoryVideo() {
        if( (this.indexVideo-1) >= 0){
            this.tabProgressValues[this.indexVideo] = 0;
            this.indexVideo--;
            this.loadVideo();
        }
    }

    nextStoryVideo(forceClose: boolean = false) {    
        if( (this.indexVideo+1) < this.stories.length){
            this.tabProgressValues[this.indexVideo] = 100;
            this.indexVideo++;
            this.loadVideo();
        }
        else if(forceClose){
            this.dismiss();
        }
    }
    
    
}
